"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _DeleteForever = _interopRequireDefault(require("@material-ui/icons/DeleteForever"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _files = require("@widergy/web-utils/lib/constants/files");

var _UTFileInput = _interopRequireDefault(require("../UTFileInput"));

var _UTLabel = _interopRequireDefault(require("../UTLabel"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Attachment = function Attachment(_ref) {
  var name = _ref.name,
      preview = _ref.preview,
      loading = _ref.loading,
      containerClassname = _ref.containerClassname,
      previewClassname = _ref.previewClassname,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      error = _ref.error,
      errorText = _ref.errorText,
      fieldTypes = _ref.fieldTypes,
      loadingTextClassname = _ref.loadingTextClassname,
      classes = _ref.classes,
      errorClassname = _ref.errorClassname,
      icon = _ref.icon,
      disabled = _ref.disabled,
      uploadingText = _ref.uploadingText;
  var fieldType = fieldTypes.map(function (type) {
    return _files.inputFiles[type].inputType;
  }).join();
  return name && !loading ? _react["default"].createElement("div", {
    className: "".concat(_stylesModule["default"].previewContainer, " ").concat(previewClassname)
  }, preview && _react["default"].createElement("img", {
    src: preview,
    className: _stylesModule["default"].preview,
    alt: ""
  }), _react["default"].createElement("div", {
    className: _stylesModule["default"].fileContainer
  }, _react["default"].createElement(_UTLabel["default"], {
    withoutMarkdown: true,
    gray: true,
    className: _stylesModule["default"].name
  }, name), _react["default"].createElement(_IconButton["default"], {
    className: _stylesModule["default"].removeIconContainer,
    onClick: onClick,
    disabled: disabled
  }, _react["default"].createElement(_DeleteForever["default"], null)))) : _react["default"].createElement(_UTFileInput["default"], {
    onChange: onChange,
    containerClassname: containerClassname,
    fileType: fieldType,
    loading: loading,
    error: error,
    loadingTextClassname: loadingTextClassname,
    classes: classes,
    errorClassname: errorClassname,
    errorText: errorText,
    icon: icon,
    disabled: disabled,
    uploadingText: uploadingText
  });
};

Attachment.propTypes = {
  name: _propTypes.string,
  preview: _propTypes.string,
  loading: _propTypes.bool,
  previewClassname: _propTypes.string,
  containerClassname: _propTypes.string,
  onClick: _propTypes.func,
  onChange: _propTypes.func,
  error: _propTypes.bool,
  errorText: _propTypes.string,
  fieldTypes: (0, _propTypes.arrayOf)(_propTypes.string),
  loadingTextClassname: _propTypes.string,
  classes: (0, _propTypes.shape)(_propTypes.any),
  errorClassname: _propTypes.string,
  icon: _propTypes.node,
  uploadingText: _propTypes.string,
  disabled: _propTypes.bool
};
var _default = Attachment;
exports["default"] = _default;